import React, { Component } from 'react';

import { Label, Headline, Button } from '../../theme';
import { Slider, Slide } from '../../carousel';
import { Oven } from '../../svg';
import { isMobile } from '../../util';

class OvenProblem extends Component {
  render() {
    return (
      <div id="Cuptor" className="container__fluid">
        <div className="w__flex w__flex-row Justify-between w__flex-column__mobile">

          <div className="w__flex w__flex-column carousel Justify-between Align-center o-2__mobile Align-right__mobile">
            <Slider device="cuptor">

              <Slide
                text="Un cuptor electric din clasa energetica A, folosit 2 ore/zi, consuma aproximativ 173 kWh/an? Modele din clase inferioare, aproape dublu."
              />

              <Slide
                text="Daca gatesti mai multe feluri de mancare o data, mai ales daca vasele folosite sunt de dimensiuni mai mici, vei obtine bonus si o factura mai mica la energia electrica?"
              />

            </Slider>
            <Button enel >
              <span className="mobile__hidden">Vezi</span>  oferta enel
            </Button>
          </div>

          <div className="w__flex w__flex-column Align-right problem__content">
            {
              !isMobile && (
                <div className="plate">
                  <Oven.Plate />
                </div>
              )
            }
            <Label marginRight="4.16vw" background="#840050" >
              problema mamei
            </Label>
            <Headline padding="4.16vw" large alignRight >
              <p style={{ color: '#840050' }}>DESCHID DES USA</p>
              <p style={{ color: '#840050', zIndex: 1 }}>CUPTORULUI<span className="punctuation">,</span></p>
              <p style={{ color: '#d33c64' }}>SA VAD CUM S-A</p>
              <p style={{ color: '#d33c64' }}>FACUT FRIPTURA</p>
            </Headline>
            <div className="birds">
              <Oven.Birds isMobile={isMobile} />
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default OvenProblem;


// WEBPACK FOOTER //
// ./src/components/pages/Cuptor/OvenProblem.jsx